export const docHeaders = [
    { key: "art", label: "art" },
    { key: "md_name", label: "name" },
    { key: "task_name", label: "task" },
    { key: "tags", label: "tags" },
    { key: "ort", label: "ort" },
    { key: "date", label: "date" },
    { key: "time", label: "time" },
    // { key: "task_weight", label: "size" },
  ];